import { render, staticRenderFns } from "./CcpItemSettings.vue?vue&type=template&id=6cdc0595&scoped=true&"
import script from "./CcpItemSettings.vue?vue&type=script&lang=js&"
export * from "./CcpItemSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc0595",
  null
  
)

export default component.exports